import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../store/slices/Recheck/recheckSlice";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { uploadAdditionalExcelFiles } from "../api";
import { useState } from "react";

const documentTypeOptions = [
  { label: "Additional Document", value: 1 },
  { label: "Delivery Challan", value: 2 },
  { label: "E-way Bill", value: 3 },
];

const useAdditionalExcelUpload = () => {
  const [loading, setLoading] = useState(false);
  const [documentType, setDocumentType] = useState(documentTypeOptions[0]);
  const dispatch = useDispatch();
  const reAssignState = useSelector((state) => state.recheck);
  const initialValues = {
    additional_document: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: "",
    onSubmit: async (values) => {
      setLoading(true);
      let newObj = Object.entries(values);
      newObj = newObj
        .filter(
          (item) => item[1] !== undefined && item[1] !== "" && item[1] !== null,
        )
        .reduce((a, v) => ({ ...a, [v[0]]: v[1] }), {});

      const formData = new FormData();
      Object.keys(newObj).forEach((key) => {
        formData.append(key, values[key]);
      });
      formData.append(
        "receipt_id",
        reAssignState?.selectedIdAdditionalUpload[0],
      );
      if (documentType) {
        formData.append("type", documentType.value);
      }
      try {
        const response = await uploadAdditionalExcelFiles(formData);
        if (response?.data?.status_code === 200) {
          setLoading(false);
          toast.success(`File uploaded successfully`);
          dispatch(
            updateConfig((state) => {
              state.additionalExcelUploadModal = false;
            }),
          );
        } else if (response?.status_code === 422 && response?.errors) {
          setLoading(false);
          Object.keys(response?.errors).forEach((field) => {
            formik.setFieldError(field, response?.errors[field]);
          });
        } else {
          setLoading(false);
          toast.error(`Unable to upload file, Please try again`);
        }
      } catch (error) {
        setLoading(false);
        console.error(`Unable to upload file:`, error);
      }
    },
  });
  const handleClose = () => {
    dispatch(
      updateConfig((state) => {
        state.additionalExcelUploadModal = false;
      }),
    );
  };

  const handleDocumentTypeChange = (option) => {
    setDocumentType(option);
    formik.setFieldValue("additional_document", "");
  };

  const handleExcelUpload = async (e) => {
    const selectedFile = e?.target?.files?.[0];
    const excelFileTypes = [
      ".csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    const pdfImageFileTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      ".csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    const allowedTypes =
      documentType?.value === 1 ? excelFileTypes : pdfImageFileTypes;
    if (selectedFile) {
      if (allowedTypes?.includes(selectedFile?.type)) {
        if (selectedFile?.size <= 2 * 1024 * 1024) {
          formik?.setFieldValue("additional_document", e?.target?.files?.[0]);
        } else {
          formik?.setFieldError(
            "additional_document",
            "File size should be less than 2MB",
          );
        }
      } else {
        const errorMsg =
          documentType?.value === 1
            ? "Invalid file type. Please upload Excel or CSV files"
            : "Invalid file type. Please upload PDF, JPG or Excel files";
        formik?.setFieldError("additional_document", errorMsg);
      }
    }
  };
  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };
  return {
    loading,
    formik,
    documentType,
    documentTypeOptions,
    handleClose,
    handleExcelUpload,
    handleDocumentTypeChange,
    getFieldError,
  };
};

export default useAdditionalExcelUpload;
